export const counties = {
    state: {
        list: []
    },
    mutations: {
        SET_LIST(state, payload) {
            state.list = payload
        }
    },
    actions: {

        async fetchCounties({ state, commit }, provinceId) {
            try {
                const response = await this.$api.get(`/api/counties/list.json?provinceId=${provinceId}`)

                commit('SET_LIST', response.data.data)

                return response
            } catch(error) {
                return null
            }
        }
    },
    getters: {
        countiesList: (state) => {
            return state.list
        }
    }
}